<div class="container">
    <div class="title-section font-24 black-color">
      <p class="font-20 black-color font-weight-500">Payment</p>
    </div>
    <mat-tab-group
      [(selectedIndex)]="activeTab"
      (selectedTabChange)="executeSelectedChange($event)"
    >
      <mat-tab label="Payment Options">
        <!-- <app-payment-options></app-payment-options> -->
        <div class="flex-column">
          <router-outlet></router-outlet>
        </div>
      </mat-tab>
      <mat-tab label="Account Billing History">
        <app-gdo-account-billing-history></app-gdo-account-billing-history>
        <!-- <div class="flex-column">
          <router-outlet></router-outlet>
        </div> -->
      </mat-tab>
    </mat-tab-group>
  </div>
  